export const normalizeEntityBeforeSaving = (tax) => {
  const entity = JSON.parse(JSON.stringify(tax));
  if (entity.accountNo && Object.keys(entity.accountNo).length === 0) {
    entity.accountNo = null;
  }

  entity.taxType = entity.taxType ? entity.taxType.code : "";
  return entity;
};
